import React, { memo, useCallback } from 'react';
import { toast } from 'react-toastify';
import GlassCard from '../card/GlassCard';
import { themeColors } from 'helpers/utils';
import { getBarTrendline } from 'helpers/chartjs-utils';
import { bitCols, defaultChartOptions } from 'services/glass-management/glassManagement';
import dayjs from 'dayjs';
import SLAChart from '../SLAChart';
import { useSelector, useDispatch } from 'react-redux';
import { openModal } from 'slices/glassDashboard/glassDataModalSlice';

const BIT = () => {
    const dispatch = useDispatch();
    const { data, loading, error } = useSelector(s => s.bit);
    if (error)
        toast.error('Something went wrong!', error);

    const formatData = useCallback(tableData =>
        tableData?.map(x => {
            return {
                ...x,
                created: dayjs(x.created).format('DD-MM-YYYY'),
            }
        }), []);

    const onChartClick = useCallback((e) => {
        if (data?.length && e?.name) {
            dispatch(openModal({
                modalData: formatData(data?.find(x => x.key === e?.name)?.jobs),
                modalLoading: false,
                modalShow: true,
                modalTitle: 'BIT',
                tableCols: bitCols,
            }));
        }
    }, [dispatch, data]);

    const showAllData = useCallback(() =>
        dispatch(openModal({
            modalData: formatData(Object.keys(data).flatMap(x => data[x].jobs)),
            modalLoading: false,
            modalShow: true,
            modalTitle: 'All BIT',
            tableCols: bitCols,
        })), [dispatch, data]);

    const getOptions = useCallback(() => {
        const xAxis = data?.map(x => x.key);
        const photos = data?.map(x => x.jobs.filter(y => y.photos.length > 0))
            .map((x, idx) => {
                return {
                    value: x?.length,
                    name: xAxis[idx],
                };
            });
        const noPhotos = data?.map(x => x.jobs.filter(y => y.photos.length === 0))
            .map((x, idx) => {
                return {
                    value: x?.length,
                    name: xAxis[idx],
                };
            });
        const chartData = xAxis?.map((name, idx) => {
            return {
                value: data[idx]?.jobs?.length,
                name,
                itemStyle: {
                    color: themeColors.info
                }
            };
        });

        return {
            ...defaultChartOptions,
            xAxis: {
                ...defaultChartOptions.xAxis,
                data: xAxis?.map(x => dayjs(x).format('ddd DD'))
            },
            tooltip: {
                trigger: 'axis',
                show: true,
                formatter: params => `${params[0]?.axisValue}: <b>${params[0]?.value + params[1]?.value}</b>`
            },
            legend: {
                data: ['Photos', 'No Photos']
            },
            series: [
                {
                    type: 'bar',
                    stack: 'Total',
                    name: 'No Photos',
                    data: noPhotos,
                    itemStyle: {
                        color: themeColors.danger
                    }
                },
                {
                    type: 'bar',
                    stack: 'Total',
                    name: 'Photos',
                    data: photos,
                    itemStyle: {
                        color: themeColors.info
                    }
                },
                {
                    ...defaultChartOptions.series[1],
                    data: getBarTrendline(chartData?.map(x => x.value))
                }
            ],
        }
    }, [data]);

    const options = getOptions();

    return (
        <>
            <GlassCard
                md={6}
                lg={4}
                title="Broken In Transit"
                heroValue={{ value: data?.reduce((a, b) => b?.jobs?.length + a, 0), prefix: '', class: 'text-info', func: showAllData }}>
                <SLAChart loading={loading} options={options} onClick={onChartClick} />
            </GlassCard>
        </>
    );
}

export default memo(BIT);